import { ClusterApi } from "@cluster/web-components";
import { CellDataTypes } from '@cluster/web-components';

export const LAYOUT_COLUMN_GAP = 30;
export const LAYOUT_OUTER_SPACING = 15;

export interface ChannelLayoutType extends Omit<ClusterApi.ComputedClusterLayout, "layout"> {
  channelWidth: number;
  channelHeight: number;
  activeTag: string;
  layout: ClusterApi.ComputedClusterCell[] | ClusterApi.ComputedClusterCell[][];
}

export interface ChannelType extends ClusterApi.Board {
  id: number;
  alerts: ClusterApi.BoardAlert[];
}

export type ChannelAlerts = {
  channel: number,
  alerts: ClusterApi.BoardAlert[]
}

export interface CellLayoutType {
  id: number,
  isCentroid: boolean,
  posCol: number,
  posRow: number,
  x: number,
  y: number,
  column?: number
  width: number,
  height: number,
}

export type CellWithLayoutType = CellDataTypes.CellType & CellLayoutType;